import { AnimatePresence, motion } from 'motion/react';
import { PropsWithChildren } from 'react';
import styled from 'styled-components';

interface MotionPortfolioProjectListProps extends PropsWithChildren {
  className?: string;
}

export const MotionPortfolioProjectList = ({
  children,
  className,
}: MotionPortfolioProjectListProps) => {
  return (
    <AnimatePresence>
      <MotionPortfolioProjectListWrapper className={className}>
        {children}
      </MotionPortfolioProjectListWrapper>
    </AnimatePresence>
  );
};

const MotionPortfolioProjectListWrapper = styled(motion.div)``;
